import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import * as addOns from './addOns/index';
import * as analytics from './analytics/index';
import * as analyticsSplashPage from './analyticsSplashPage/index';
import * as auth from './auth/index';
import * as common from './common/index';
import * as contacts from './contacts/index';
import * as customInterrogations from './customInterrogations/index';
import * as customWidgets from './customWidgets/index';
import * as dashboard from './dashboard/index';
import * as differentOrganization from './differentOrganizationPage/index';
import * as digiQuote from './digiQuote/index';
import * as discounts from './discounts/index';
import * as downloads from './downloads/index';
import * as fileViewer from './fileViewer/index';
import * as materialListPage from './materialListPage/index';
import * as metrics from './metrics/index';
import * as notifications from './notifications/index';
import * as opDefs from './opDefs/index';
import * as orders from './orders/index';
import * as partLibrary from './partLibrary/index';
import * as processes from './processes/index';
import * as profitItems from './profitItems/index';
import * as purchasedComponents from './purchasedComponents/index';
import * as quotePartViewer from './quotePartViewer/index';
import * as quotes from './quotes/index';
import * as relay from './relay/index';
import * as rules from './rules';
import * as settings from './settings/index';
import * as supplierTables from './supplierTables/index';
import * as tasks from './tasks/index';
import * as vectorEditor from './vectorEditor/index';
import * as vectorFileEditor from './vectorFileEditor/index';
import * as viewer from './viewerPage/index';
import * as workflows from './workflows/index';

export const reducer = combineReducers({
  addOns: addOns.reducer,
  analytics: analytics.reducer,
  auth: auth.reducer,
  common: common.reducer,
  contacts: contacts.reducer,
  customInterrogations: customInterrogations.reducer,
  customWidgets: customWidgets.reducer,
  dashboard: dashboard.reducer,
  digiQuote: digiQuote.reducer,
  discounts: discounts.reducer,
  fileViewer: fileViewer.reducer,
  materialListPage: materialListPage.reducer,
  notifications: notifications.reducer,
  opDefs: opDefs.reducer,
  partLibrary: partLibrary.reducer,
  processes: processes.reducer,
  profitItems: profitItems.reducer,
  purchasedComponents: purchasedComponents.reducer,
  quotePartViewer: quotePartViewer.reducer,
  quotes: quotes.reducer,
  settings: settings.reducer,
  supplierTables: supplierTables.reducer,
  tasks: tasks.reducer,
  vectorEditor: vectorEditor.reducer,
  vectorFileEditor: vectorFileEditor.reducer,
  viewerPage: viewer.reducer,
  workflows: workflows.reducer,
});

export const saga = function* () {
  yield all([
    addOns.saga(),
    auth.saga(),
    common.saga(),
    contacts.saga(),
    customInterrogations.saga(),
    customWidgets.saga(),
    dashboard.saga(),
    digiQuote.saga(),
    discounts.saga(),
    materialListPage.saga(),
    notifications.saga(),
    opDefs.saga(),
    partLibrary.saga(),
    processes.saga(),
    profitItems.saga(),
    purchasedComponents.saga(),
    quotePartViewer.saga(),
    quotes.saga(),
    settings.saga(),
    supplierTables.saga(),
    tasks.saga(),
    vectorEditor.saga(),
    vectorFileEditor.saga(),
    viewer.saga(),
    workflows.saga(),
  ]);
};

const processesRoutes = [
  ...addOns.routes,
  ...customInterrogations.routes,
  ...materialListPage.routes,
  ...opDefs.routes,
  ...profitItems.routes,
  ...discounts.routes,
  ...purchasedComponents.routes,
  ...supplierTables.routes,
  ...workflows.routes,
  ...rules.routes,
  // the routes above must go before processes.routes because their URLs conflict with processes/:processId
  ...processes.routes,
];

export const loggedOutRoutes = [...auth.routes, ...downloads.routes];

export const loggedInRoutes = [
  ...analytics.routes,
  ...analyticsSplashPage.routes,
  ...contacts.routes,
  ...dashboard.routes,
  ...differentOrganization.routes,
  ...metrics.routes,
  ...notifications.routes,
  ...orders.routes,
  ...partLibrary.routes,
  ...processesRoutes,
  ...quotes.routes,
  ...settings.routes,
  ...tasks.routes,
  ...relay.routes,
];

export const viewerRoutes = [
  ...fileViewer.routes,
  ...quotePartViewer.routes,
  ...vectorEditor.routes,
  ...vectorFileEditor.routes,
  ...viewer.routes,
];
